<div class="modal">
  <div class="feedback-modal">
    <div class="tick-illustration">
      <div [innerHTML]="feedbackTickSvg"></div>
    </div>
    <h4>Thanks for your feedback!</h4>
  </div>
</div>
